// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"560":"becb87ad","635":"4a850943","708":"4f1ed6c6","763":"d2f4760e","826":"1710db24"}[chunkId] + ".chunk.css";
};